import type { ReactNode } from 'react';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import './ui.css';

export interface DetailRow {
  label: string;
  /** A blank string renders the "not set" placeholder rather than an empty cell. */
  value: ReactNode;
}

interface DetailListProps {
  rows: readonly DetailRow[];
}

/** Label/value pairs for read-only record facts. */
export function DetailList({ rows }: DetailListProps) {
  const { t } = useTranslation('admin');

  return (
    <dl className="ui-detail">
      {rows.map(row => (
        <div className="ui-detail__row" key={row.label}>
          <dt className="ui-detail__label">{row.label}</dt>
          <dd className="ui-detail__value">
            {row.value === '' || row.value == null ? t('common.none') : row.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
